import Layout from "../../components/global/layout"
import { IoEyeOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import loader from "../../methods/loader";
import ApiClient from "../../methods/api/apiClient";
import methodModel from "../../methods/methods";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import Pagination from "react-js-pagination";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import environment from "../../environment";

const MyCards = () => {
    const [cards, setCards]: any = useState([])
    const navigate = useNavigate()
    const user = useSelector((state: any) => state.user)
    const [filter, setFilter] = useState({ page: 1, count: 10, search: "", total: 0 })

    useEffect(() => {
        getMyCards()
    }, [])

    const getMyCards = (f = {}) => {
        let payload: any = { ...filter, ...f }
        if (user?.role?._id === environment.recipientRole) {
            payload = {
                ...payload,
                recipient_email: user?.email
            }
        } else {
            payload = {
                ...payload,
                userId: user?._id || user?.id
            }
        }
        loader(true)
        delete payload?.total // No need for total key
        ApiClient.get(`payNow/card/list`, payload).then(res => {
            if (res.success) {
                setCards(res?.data)
                setFilter((prev: any) => ({ ...prev, total: res?.total }))
            }
            loader(false)
        })
    }

    const handleSearch = (e: any) => {
        e.preventDefault()
        getMyCards({ search: filter?.search })
    }

    const clear = () => {
        setFilter((prev: any) => ({ ...prev, search: "" }))
        getMyCards({ search: "" })
    }

    const handlePagination = (e: any) => {
        setFilter({ ...filter, page: e });
        getMyCards({ page: e });
    }

    const blockLeftclick = (e: any) => {
        if (e.button === 0) {
            e.preventDefault();
        }
    };
    document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
    });

    useEffect(() => {
        const blockKeys = (e: any) => {
            if (
                (e.key === 'F12') ||
                (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) ||
                (e.key === 'F11') ||
                (e.ctrlKey && e.keyCode == 80 || e.metaKey && e.keyCode == 80) ||
                (e.keyCode === '44') ||
                (e.key === 'F10')
            ) {
                e.preventDefault();
            }
        };
        document.addEventListener('keydown', blockKeys);
        return () => {
            document.removeEventListener('keydown', blockKeys);
        };
    }, []);

    return (
        <>
            <Layout>
                <div>
                    <div className="section-listinngs px-4 lg:px-16 pt-6">
                        <div className="mb-10 flex items-center justify-between">
                            <h4 className="text-[30px] text-[#292F36]">My Cards</h4>
                            <form onSubmit={handleSearch} className="relative">
                                <FormControl
                                    type="text"
                                    name="search"
                                    value={filter?.search}
                                    onChange={(e: any) => setFilter((prev: any) => ({ ...prev, search: e }))}
                                    placeholder="Search..."
                                    className="relative shadow bg-white border border-gray-100 w-full rounded-lg h-12 flex items-center gap-2 overflow-hidden px-2"
                                />
                                {filter?.search && <IoMdClose size={18} onClick={e => clear()} className="absolute top-3 right-2 hover:text-red-600 cursor-pointer" />}
                                <button type="submit" className="hidden"></button>
                            </form>
                        </div>
                        <div className="grid grid-cols-12 gap-4 xl:gap-8">
                            <div className="col-span-12 md:col-span-12">
                                <div className="overflow-auto">
                                    <table className="w-full">
                                        <thead className="bg-[#F6EFE9] mb-4">
                                            <tr>
                                                <th className="text-left px-4">Card</th>
                                                <th className="text-left px-4">Name</th>
                                                <th className="text-left px-4">Sender Name</th>
                                                <th className="text-left px-4">Sender Email</th>
                                                {user?.role?._id !== environment.recipientRole &&
                                                    <>
                                                        <th className="text-left px-4">Recipient Name</th>
                                                        <th className="text-left px-4">Recipient Email</th>
                                                        <th className="text-left px-4">Recipient Mobile Number</th>
                                                        <th className="text-left px-4">Price</th>
                                                    </>
                                                }                                                
                                                <th className="text-left px-4"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cards?.map((item: any, index: number) => {
                                                return <tr className="mt-4 border-t border-gray-200" key={index}>
                                                    <td className="px-4 p-4">
                                                        <Tooltip title="View">
                                                            <img onMouseDown={blockLeftclick} src={methodModel.noImg(item?.cartDetail?.images?.["1"])} onClick={e => { navigate(`/mycard/${item?._id || item?.id}`) }} className="h-20 cursor-pointer" />
                                                        </Tooltip>
                                                    </td>
                                                    <td className="capitalize">{item?.cartDetail?.customizeCardDetail?.name || "--"}</td>
                                                    <td className="capitalize">{item?.fullName || "--"}</td>
                                                    <td>{item?.email || "--"}</td>
                                                    {user?.role?._id !== environment.recipientRole &&
                                                        <>
                                                            <td className="capitalize">{item?.cartDetail?.recipient_name || "--"}</td>
                                                            <td>{item?.cartDetail?.recipient_email || "--"}</td>
                                                            <td>{item?.cartDetail?.recipient_mobileNo ? `+${item?.cartDetail?.recipient_dialCode} ${item?.cartDetail?.recipient_mobileNo}` : "--"}</td>
                                                            <td>${item?.cartDetail?.price || 0}</td>
                                                        </>
                                                    }
                                                    <td>
                                                        <Tooltip title="View">
                                                            <IoEyeOutline onClick={e => { navigate(`/mycard/${item?._id || item?.id}`) }} className="text-xl cursor-pointer hover:text-[#F58D18]" />
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            })}
                                            {cards?.length === 0 &&
                                                <tr className="text-center">
                                                    <td className="px-4 p-4" colSpan={5}>
                                                        No Cards
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                    {filter?.total > filter?.count ?
                                        <div className="mt-10 flex items-center justify-end">
                                            <Pagination
                                                activePage={filter?.page}
                                                itemsCountPerPage={filter?.count}
                                                totalItemsCount={filter?.total}
                                                pageRangeDisplayed={1}
                                                onChange={handlePagination}
                                                hideFirstLastPages={true}
                                            />
                                        </div>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default MyCards